import { createSlice } from "@reduxjs/toolkit";

export const slaTableFiltersSlice = createSlice({
    name: 'slaTableFilters',
    initialState: {
        searchVal: '',
        filters: {
            withinSla: { value: null },
        },
    },
    reducers: {
        setSearchVal: (state, action) => {
            state.searchVal = action.payload;
        },
        setFilters: (state, action) => {
            state.filters = action.payload;
        }
    },
});

export const { setSearchVal, setFilters } = slaTableFiltersSlice.actions;
export default slaTableFiltersSlice.reducer;
